<template>
    <div class="open-field grid">
        <app-question :data-heading="dataInteraction.descricao"
                      :data-color="dataInteraction.estilo.question.color"></app-question>

        <div class="grid-center">
            <open-field-input :openFieldStyle="openFieldStyle"/>
        </div>
        
        <div class="grid-bottom text-center">           
            <template v-for="(option, index) in dataInteraction.opcoes" >        
                <button class="btn btn-stretch btn-extra-round text-bold"
                        :key="index"
                        :id="index"  
                        :style="buttonStyle(option.estilo)"
                        @click="(event) => showLinks({event, interaction})">
                        {{option.nome}}
                </button>
            </template>
        </div>
        
        <button class="clear-connections btn btn-stretch btn-extra-round text-bold"
                v-if="isShowingLinks && hasActiveLinks"
                @click="clearConnections($event)">Limpar conexões</button>      
    </div>
</template>
  
<script>
import buttonStyle from "../../mixins/button-style";
import mode from "../../mixins/mode";
import linkable from "../../mixins/linkable";
import AppQuestion from '../Question'
import OpenFieldInput from "./input/OpenFieldInput";

export default {
    components: {
        AppQuestion,
        OpenFieldInput
    }, 

    props: {
        dataInteraction: {
            type: Object,
            required: true,
        },
    },

    computed: {        
        itemStyle() {
            return this.dataInteraction.estilo ? this.dataInteraction.estilo : null
        },

        backgroundType() {
            return this.itemStyle ? this.itemStyle.backgroundType : null
        },

        openFieldStyle() {
            return this.dataInteraction.estilo.openField
        }        
    },

    mixins: [buttonStyle, mode, linkable],
};
</script>
  
<style lang="scss" scoped>
@import "~@variables";

.open-field {
    &.grid {
        .grid-center{
            display: flex;
            justify-content: center;
            width: 100%;
            padding: 20px 34px 42px;
           
        }
        .grid-bottom {
            gap: 2.5%;
            margin: 0 2.5%;
        }

        .btn {
            &.clear-connections {
                font-size: 14px;
                position: fixed;
                bottom: 15px;
                left: 40%;
                min-width: 0 !important;
                width: 20% !important;
                background-color: #2a7155;
                z-index: 10000;
                color: white;
                min-width: 0;

                &:hover {
                    transform: translateY(-1px);
                }

                &:active {
                    transform: translateY(1px);
                }
            }        
        }
    }
}
</style>
  
